import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {AuthenticationService} from '../../services/apiServices/security/authentication.service';
import {MessageService} from 'primeng/api';
import {TranslateService} from '@ngx-translate/core';
import {FoldDetailService} from '../../services/apiServices/business/fold-detail.service';
import {JwtHelperService} from '@auth0/angular-jwt';
import {HttpService} from '../../services/apiServices/http-service.service';
import {CommonService} from '../../services/apiServices/business/common.service';
import {FileSaverService} from 'ngx-filesaver';
import {ModService} from '../../services/apiServices/business/mod.service';

/**
 * Component that handle the creation of a new password (not change!)
 * it use the create-password component to handle the creation
 */
@Component({
  selector: 'app-download-report-file',
  templateUrl: './download-report-file.component.html',
  styleUrls: ['./download-report-file.component.scss']
})
export class DownloadReportFileComponent implements OnInit {


  /**
   * the token temporary gave by the back-office
   */
  private temporaryToken: string;

  /**
   * the errorMessage (if the back-office gave one)
   */
  public errorMessage: string;
  public validToken: boolean;

  /**
   * Message display when the new password is ok
   */
  public archiveNotFoundMsg: string;
  public invalidTokenMsg: string;
  public messageHeader: string;
  jwtHelper: JwtHelperService;
  /**
   * Title of the message, display when the new password is ok
   */
  public successTitle: string;


  constructor(private route: ActivatedRoute, private router: Router,
              private  authenticationService: AuthenticationService,
              private fileSaverService: FileSaverService,
              private  foldDetailService: FoldDetailService,
              private commonService: CommonService,
              private modService: ModService,
              private httpService: HttpService,
              private translate: TranslateService) {
    this.jwtHelper = new JwtHelperService();
  }

  /**
   * obtain translation from TranslateService
   */
  private getTradForComponent(): void {
    this.translate.get('TOASTER.SUCCESS_MESSAGE_TITLE').subscribe((title: string) => {
      this.successTitle = title;
    });
    this.translate.get('REPPORT_DOWNLOAD.REPORT_NOT_FOUND').subscribe(message => {
      this.archiveNotFoundMsg = message;
    });
    this.translate.get('REPPORT_DOWNLOAD.MESSAGE_HEADER').subscribe(message => {
      this.messageHeader = message;
    });
    this.translate.get('REPPORT_DOWNLOAD.INVALID_TOKEN').subscribe(message => {
      this.invalidTokenMsg = message;
      if (! this.validToken) {
        this.commonService.addToast({
          life: 5000,
          severity: 'error',
          summary: this.messageHeader,
          detail: this.invalidTokenMsg
        });
      }
    });
  }

  /**
   * handleChangeOfSelectFold queryParams, logging out and subscriptions to errorMessage (from passwordService)
   */
  public ngOnInit(): void {
    this.validToken = true;
    this.temporaryToken = this.route.snapshot.queryParams['t'] || '/';
    let decodedToken;
    try {
      decodedToken = this.jwtHelper.decodeToken(this.temporaryToken);
    } catch (e) {
      this.validToken = false;
    }
    this.httpService.get('../assets/messageOfTheDay.json').subscribe( (response: any ) => {
      if (response && response.MOTD_CONTENT_FR) {
        this.translate.set('MOTD_CONTENT', response.MOTD_CONTENT_FR, 'fr');
      }
      if (response && response.MOTD_CONTENT_EN) {
        this.translate.set('MOTD_CONTENT', response.MOTD_CONTENT_EN, 'en');
      }
    });

    this.getTradForComponent();
  }
  public getUserMessageOfTheDay(): string {
    return this.modService.getUserMessageOfTheDay();
  }
  public download() {
    if (!this.validToken) {
      this.commonService.addToast({
        life: 5000,
        severity: 'error',
        summary: this.messageHeader,
        detail: this.invalidTokenMsg
      });
      return;
    }
    const t = this.foldDetailService.getReportFile(this.temporaryToken);
    this.foldDetailService.getReportFile(this.temporaryToken).subscribe(response => {
        const typeOfReponse = response.headers.get('content-type');
        if (typeOfReponse && !typeOfReponse.includes('application/json')) {
          if (response.body.size > 0) {
            const blob = new Blob([ response.body ], {type: response.headers.get('content-type')});
            let fileName = response.headers.get('content-disposition');
            const prefix = 'inline; filename=';
            if (fileName.indexOf(prefix) === 0) {
              fileName = fileName.replace(prefix, '');
              fileName = fileName.replace(';', '');
            } else {
              fileName = 'report.csv';
            }
            this.fileSaverService.save(blob, fileName);
          } else {
            this.commonService.addToast({
              life: 5000,
              severity: 'error',
              summary: this.messageHeader,
              detail: this.archiveNotFoundMsg
            });
          }
        }
        else {
          this.commonService.addToast({
            life: 5000,
            severity: 'error',
            summary: this.messageHeader,
            detail: this.archiveNotFoundMsg
          });
        }
      }
    );
  }
}
